import Button from "@/components/base/Button";
import ProcessFlow from "@/components/base/ProcessFlow";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const NODES = [
  {
    icon: "ri-compass-3-line",
    title: "信念系統",
    desc: "理解自己怎麼看待自己、問題與可能性。",
  },
  {
    icon: "ri-rocket-2-line",
    title: "行動系統",
    desc: "把目標變成真正可以開始、執行與調整的行動。",
  },
  {
    icon: "ri-road-map-line",
    title: "人生系統",
    desc: "讓每天的努力，逐漸走向自己真正重視的方向。",
  },
];

export default function MethodSection() {
  return (
    <section className="bg-primary-dark">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-20 lg:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="幸福人才方法"
            title="改變，不應該只靠一時的意志力。"
            dark
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {NODES.map((n, i) => (
            <Reveal key={n.title} delay={i * 90}>
              <div className="h-full rounded-card bg-white/5 border border-white/10 p-7 transition-transform duration-300 hover:-translate-y-1">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-gold/20">
                  <i className={`${n.icon} text-2xl text-gold`} aria-hidden="true"></i>
                </div>
                <h3 className="mt-5 text-xl font-bold text-white">{n.title}</h3>
                <p className="mt-3 text-sm leading-[1.8] text-gold-soft/90">{n.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-14">
            <ProcessFlow
              dark
              steps={[
                { title: "看見" },
                { title: "改變" },
                { title: "建立" },
                { title: "持續" },
                { title: "影響" },
              ]}
            />
          </div>
        </Reveal>

        <Reveal delay={160}>
          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <Button to="/happiness-talent-system" variant="outline-light" icon="ri-arrow-right-line">
              深入了解幸福人才養成系統
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}